module.exports = __webpack_public_path__ + "static/media/CrimsonText-Bold.060a8117.ttf";